import styled from 'styled-components'

export const ContainerForm = styled.div`
  width: 100%;
  height: auto;
  padding-top: 70px;
  padding-right: 70px;
  padding-left: 146px;
  padding-bottom: 146px;
  border-radius: ${({ theme }) => theme.border.radius.medium};
  background: white;
  margin-top: 20px;
  flex-shrink: 0;
`

export const HeaderButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 57px;
  margin-bottom: 32px;
  flex-shrink: 0;
`
